import { render, staticRenderFns } from "./FailedDdPaymentCharges.vue?vue&type=template&id=767e38c5&"
import script from "./FailedDdPaymentCharges.vue?vue&type=script&lang=js&"
export * from "./FailedDdPaymentCharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FailedDdPaymentCharges.vue"
export default component.exports